import script from "./Page8.vue?vue&type=script&setup=true&lang=js"
export * from "./Page8.vue?vue&type=script&setup=true&lang=js"

import "./Page8.vue?vue&type=style&index=0&id=eef635fe&lang=less"

const __exports__ = script;

export default __exports__